import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import type { OrderSource } from "./types"
import type { Dictionary } from "../../../../utils/types"

export const CLEAR_ORDERS_DATA = "CLEAR_ORDERS_DATA"

export const clearOrdersData = () => ({
    type: CLEAR_ORDERS_DATA,
})

export const ORDERS_AGENDA_MOUNTED = "ORDERS_AGENDA_MOUNTED"

export const ordersAgendaMounted = () => ({
    type: ORDERS_AGENDA_MOUNTED,
})

export const EDIT_ORDER_OPENED = "EDIT_ORDER_OPENED"

export const editOrderOpened = (orderId: Maybe<string>) => ({
    type: EDIT_ORDER_OPENED,
    payload: {
        orderId: orderId,
    },
})

export const CLOSE_ORDER_FORM_CLICKED = "order/close/clicked"

export const closeOrderFormClicked = () => ({
    type: CLOSE_ORDER_FORM_CLICKED,
})

export const SEND_ORDER_EMAIL_CLICKED = "order/send/clicked"

export const sendOrderEmailClicked = (
    orderId: string,
    transactionId: Maybe<string>,
    email: string,
    orderSource: Maybe<OrderSource>
) => ({
    type: SEND_ORDER_EMAIL_CLICKED,
    payload: {
        orderId: orderId,
        transactionId: transactionId,
        email: email,
        orderSource: orderSource,
    },
})

export const SEND_ORDER_EMAIL_SUCCESS = "order/send/email/success"

export const sendOrderEmailSuccess = () => ({
    type: SEND_ORDER_EMAIL_SUCCESS,
})

export const SEND_ORDER_EMAIL_FAILURE = "order/send/email/failure"

export const sendOrderEmailFailure = () => ({
    type: SEND_ORDER_EMAIL_FAILURE,
})

export const SEND_ORDER_EMAIL_RESET_DEFAULT = "order/send/email/reset"

export const sendOrderEmailResetDefault = () => ({
    type: SEND_ORDER_EMAIL_RESET_DEFAULT,
})

export const GET_PAYMENT_REQUEST_DETAIL_REQUESTED = "order/get/paymentRequest/requested"

export const getPaymentRequestDetailRequested = (id: Maybe<string>) => ({
    type: GET_PAYMENT_REQUEST_DETAIL_REQUESTED,
    payload: {
        id: id,
    },
})

export const GET_PAYMENT_REQUEST_DETAIL_SUCCESS = "order/get/paymentRequest/success"

export const getPaymentRequestDetailSuccess = (data: Dictionary) => ({
    type: GET_PAYMENT_REQUEST_DETAIL_SUCCESS,
    payload: {
        data: data,
    },
})
